module.exports = __webpack_public_path__ + "img/rt.b5698d64.jpg";